import Phaser from 'phaser';
import gameData, { GameShortNames } from '../gameData';
import Pipe from './Pipe';
import ABCyaPhaser from '@abcya/abcya_phaser';
import UIAssetKeys from '../UIAssetKeys';
import Present from './Present';
import { checkPixelCollision } from '../ndgmr.Collision-phaser';

export default class ActiveObjects extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.spawnTime = 3.5;
    this.baseSpawnTime = 3.5;

    this.pipes = null;
    this.pipePool = null;
    this.pipeSpeed = 180;

    this.gaps = null;

    this.pipeWaiter = null;

    this.presents = null;
    this.presentPool = null;
    this.presentWaitTime = null;
    this.presentWaiter = null;

    this.powerup = null;
    this.powerupWaiter = null;
    this.minPowerupWait = 2; //  multiple of spawn time
    this.maxPowerupWait = 5;

    this.worldSpeed = 1;
    this.playerPoweredUp = false;
    this.blinking = false;// for spawning new pipes

    this.tmpGap = { top: 0,bottom: 0 };
    this.latestGap = { top: 0,bottom: 0 };
    this.gapLevel = 0;
    if (gameData.game === GameShortNames.jr) {
      this.gaps = gameData.GameSettings.JR_GAPS;
      this.baseSpawnTime = 4.8;
      this.spawnTime = this.baseSpawnTime;
    }
    else {
      this.gaps = gameData.GameSettings.NORMAL_GAPS;
    }
    this.minGap = this.gaps[this.gapLevel][0];
    this.maxGap = this.gaps[this.gapLevel][1];

    this.minSpawnY = 0;
    this.maxSpawnY = 315;

    this.pipes = [];
    this.pipePool = [
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
      new Pipe(this.scene),
    ];

    const pipeFrame = this.scene.textures.getFrame(ABCyaPhaser.Images.DEFAULT_ATLAS, UIAssetKeys._Obstacle_Bottom);

    this.pipeHeight = pipeFrame.height;
    this.pipeWidth = pipeFrame.width;

    this.pipeWaiter = 1;

    this.presents = [];
    this.presentPool = [
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
      new Present(this.scene),
    ];

    this.resetSpawnTimers();
  }

  resetSpawnTimers (time = 1) {
    this.pipeWaiter = time;
    this.presentWaiter = time + this.spawnTime / 2;
    this.powerupWaiter = time + this.presentWaiter + (this.spawnTime * Phaser.Math.Between(this.minPowerupWait, this.maxPowerupWait));
  }

  spawnActiveObjects () {
    this.getGap();
    this.spawnPipe(this.tmpGap.top, true);
    this.spawnPipe(this.tmpGap.bottom, false);
    this.latestGap.top = this.tmpGap.top + this.pipeHeight;
    this.latestGap.bottom = this.tmpGap.bottom;
  }

  spawnPipe (y,istop) {
    const pipe = this.pipePool.pop();
    const a = this.playerPoweredUp ? 0.4 : 1.0;
    pipe.reset(istop, y, this.pipeSpeed, a);
    pipe.blinking = this.blinking;
    this.pipes.push(pipe);
    this.add(pipe.setVisible(true)).bringToTop(pipe);
  }

  returnPipe (i) {
    const pipe = this.pipes[i];
    pipe.setVisible(false);
    this.pipePool.push(pipe);
    this.pipes.splice(i,1);
  }

  spawnPresent () {
    let y = this.latestGap.top + (this.latestGap.bottom - this.latestGap.top) / 2;
    if (this.playerPoweredUp) {
      y = Phaser.Math.Between(200,this.scene.scale.height - 200);
    }
    const present = this.presentPool.pop();
    if (present === undefined) {
      console.warn('not enough presents!!!!');
      return;
    }
    present.reset(y);
    present.vX = -this.pipeSpeed;
    this.presents.push(present);
    this.add(present.setVisible(true)).bringToTop(present);
  }

  returnPresent (i) {
    const present = this.presents[i];
    present.setVisible(false);
    this.presentPool.push(present);
    this.presents.splice(i,1);
  }

  spawnPowerup () {
    if (this.powerup) {
      console.log('already powerup spawned');
      return;
    }
    const y = Phaser.Math.Between(1,this.scene.scale.height - 300) + 150;
    const powerup = this.presentPool.pop();
    powerup.vX = -240;
    powerup.makeStar(y);
    this.add(powerup.setVisible(true)).bringToTop(powerup);
    this.powerup = powerup;
  }

  returnPowerup () {
    this.powerup.setVisible(false);
    this.presentPool.push(this.powerup);
    this.powerup = null;
  }

  getGap () {
    const gap = Phaser.Math.Between(this.minGap,this.maxGap);
    let t = Phaser.Math.Between(this.minSpawnY, this.maxSpawnY) * -1;
    let b = t + gap + this.pipeHeight;
    if (this.playerPoweredUp && this.blinking === false) {
      t = -this.maxSpawnY;
      b = this.scene.scale.height - 80;
    }
    this.tmpGap.top = t;
    this.tmpGap.bottom = b;
  }

  setGapProps (min,max) {
    this.minGap = min;
    this.maxGap = max;
  }

  upGapLevel () {
    if (this.gapLevel < this.gaps.length - 1) {
      this.gapLevel++;
    }
    this.minGap = this.gaps[this.gapLevel][0];
    this.maxGap = this.gaps[this.gapLevel][1];
  }

  resetGaps () {
    this.gapLevel = 0;
    this.minGap = this.gaps[this.gapLevel][0];
    this.maxGap = this.gaps[this.gapLevel][1];
  }

  cleanObjects () {
    let len = this.pipes.length;
    for (let i = 0; i < len; i++) {
      this.pipes[i].setVisible(false);
      this.pipePool.push(this.pipes[i]);
    }
    this.pipes = [];
    len = this.presents.length;
    for (let i = 0; i < len; i++) {
      this.presents[i].setVisible(false);
      this.presentPool.push(this.presents[i]);
    }
    this.presents = [];
    if (this.powerup) {
      this.powerup.setVisible(false);
      this.presentPool.push(this.powerup);
      this.powerup = null;
    }
  }

  changeForPowerup (worldspeed) {
    this.worldSpeed = worldspeed;
    this.playerPoweredUp = true;

    this.pipeSpeed = 180 * worldspeed;

    let len = this.pipes.length - 1;
    for (let i = len; i >= 0; i--) {
      this.pipes[i].vX = -(180 * worldspeed);

      this.presentWaiter = 0;
      this.pipes[i].alpha = 0.4; // gonna alpha the pipes out
    }
    this.blinking = false;
    len = this.presents.length;

    for (let i = 0; i < len; i++) {
      this.presents[i].vX = -this.pipeSpeed;
    }
    this.powerupWaiter = this.spawnTime * Phaser.Math.Between(this.minPowerupWait,this.maxPowerupWait) + 12 + 3;// 12 is power up time
  }

  windSpeed (worldspeed) {
    this.worldSpeed = worldspeed;
    this.pipeSpeed = 180 * worldspeed;

    let len = this.pipes.length - 1;
    for (let i = len; i >= 0; i--) {
      this.pipes[i].vX = -(180 * worldspeed);
    }
    len = this.presents.length;
    for (let i = 0; i < len; i++) {
      this.presents[i].vX = -(this.worldSpeed * 180);
    }
  }

  endPowerup (worldspeed) {
    this.worldSpeed = worldspeed;
    this.playerPoweredUp = false;

    this.pipeSpeed = 180 * worldspeed;

    // reset the power up timer to realign them back up with the candy canes
    this.powerupWaiter = 1 + this.presentWaiter + (this.spawnTime * Phaser.Math.Between(this.minPowerupWait, this.maxPowerupWait));

    let len = this.pipes.length - 1;
    for (let i = len; i >= 0; i--) {
      this.pipes[i].vX = -(180 * worldspeed);
      this.pipes[i].alpha = 1;
    }
    len = this.presents.length;

    for (let i = 0; i < len; i++) {
      this.presents[i].vX = -this.pipeSpeed;
    }
  }

  setBlink (value) {
    this.blinking = value;
    const len = this.pipes.length;
    for (let i = 0; i < len; i++) {
      this.pipes[i].blinking = this.blinking;
    }
  }

  tick (dt) {
    let len = this.pipes.length - 1;
    for (let i = len; i >= 0; i--) {
      this.pipes[i].tick(dt);
      if (this.pipes[i].x < -this.pipeWidth) {
        this.returnPipe(i);
      }
    }

    if (this.pipeWaiter <= 0) {
      this.spawnActiveObjects();
      this.pipeWaiter = this.spawnTime;
    }
    else {
      this.pipeWaiter -= dt * this.worldSpeed;
    }

    len = this.presents.length - 1;
    for (let i = len; i >= 0; i--) {
      this.presents[i].tick(dt);
      if (this.presents[i].x < -this.pipeWidth) {
        this.returnPresent(i);
      }
    }

    if (this.powerup) {
      this.powerup.tick(dt);
      if (this.powerup.x < -this.pipeWidth) {
        this.returnPowerup();
      }
    }

    if (this.presentWaiter <= 0) {
      this.spawnPresent();
      this.presentWaiter = this.spawnTime;
      if (this.playerPoweredUp) {
        if (this.blinking === false) {
          const r = Phaser.Math.Between(11,29) / 100;
          this.presentWaiter = this.spawnTime * r;
        }
        else {
          // reset the present waiter so that it realigns with the candy canes (presents spawn in the center between two canes)
          this.presentWaiter = this.pipeWaiter + this.baseSpawnTime / 2;
        }
      }
    }
    else {
      this.presentWaiter -= dt * this.worldSpeed;
    }

    if (this.powerupWaiter <= 0) {
      this.spawnPowerup();
      this.powerupWaiter = this.spawnTime * Phaser.Math.Between(this.minPowerupWait,this.maxPowerupWait);
    }
    else {
      this.powerupWaiter -= dt;
    }
  }

  checkCollision (sprite, sprite2, skipObstacles) {
    let len = 0;
    let whichSprite;
    if (skipObstacles !== true) {
      len = this.pipes.length;
      for (let i = 0; i < len; i++) {
        if (!this.pipes[i].active === false) {
          let col = checkPixelCollision(sprite,this.pipes[i]);
          if (col) whichSprite = sprite.x;

          if (!col) col = checkPixelCollision(sprite2,this.pipes[i]);
          if (col) {
            if (!whichSprite) whichSprite = sprite2.x;
            this.emit('HIT_OBSTACLE', this.pipes[i], whichSprite, sprite2.y);
            this.pipes[i].active = false;
            this.returnPipe(i);
            break;
          }
        }
      }
    }

    if (this.powerup) {
      let col = checkPixelCollision(sprite,this.powerup);
      if (!col) col = checkPixelCollision(sprite2,this.powerup);
      if (col) {
        this.emit('HIT_POWERUP');
        this.returnPowerup();
      }
    }

    len = this.presents.length;
    for (let i = 0; i < len; i++) {
      if (this.presents[i].active) {
        let col = checkPixelCollision(sprite,this.presents[i]);
        if (!col) col = checkPixelCollision(sprite2, this.presents[i]);
        if (col) {
          this.emit('HIT_PRESENT', this.presents[i]);
          this.presents[i].active = false;
          this.returnPresent(i);
          break;
        }
      }
    }
  }
}